import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { ToastProvider } from 'components/Toast';
import { ConfigProvider } from 'config/ConfigProvider';
import { ReCaptchaWrapper } from 'config/ReCaptchaWrapper';

import Application from './containers/App';
import configureStore from './store';
import reportWebVitals from './reportWebVitals';
import './assets/styles/global.scss';

const store = configureStore({});

const render = () => {
  createRoot(document.getElementById('root')).render(
    <ConfigProvider>
      <ReCaptchaWrapper>
        <Provider store={store}>
          <ToastProvider>
            <BrowserRouter>
              <React.StrictMode>
                <Application />
              </React.StrictMode>
            </BrowserRouter>
          </ToastProvider>
        </Provider>
      </ReCaptchaWrapper>
    </ConfigProvider>
  );
};

setTimeout(() => render(), 1200);
reportWebVitals();
